import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Award icon for achievements and quiz completion
 */
export const AwardIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <circle cx="12" cy="8" r="7"></circle>
      <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
    </Icon>
  );
};

export default AwardIcon;
